import { Outlet, useLocation } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { Sidebar } from './Sidebar';
import { MobileBottomBar } from './MobileBottomBar';
import { InactiveClinicBanner } from '@/components/InactiveClinicBanner';
import { isCommunicationInboxPath, isPatientRecordWorkspacePath } from './sidebarNav';
import { cn } from '@/utils/cn';

export function MainLayout() {
  const { t } = useTranslation();
  const location = useLocation();
  const fillViewport =
    location.pathname.startsWith('/appointments') ||
    isCommunicationInboxPath(location.pathname) ||
    isPatientRecordWorkspacePath(location.pathname);

  return (
    <div className="flex h-screen min-h-0 flex-col overflow-x-clip">
      <a href="#main-content" className="skip-link">
        {t('nav.skip_to_content')}
      </a>
      <div className="flex min-h-0 flex-1">
        <Sidebar />
        <main
          id="main-content"
          tabIndex={-1}
          className="flex min-w-0 flex-1 flex-col overflow-hidden bg-ds-bg outline-none"
        >
          <InactiveClinicBanner />
          <div
            className={cn(
              'page-scroll min-w-0',
              fillViewport
                ? 'flex min-h-0 flex-1 flex-col overflow-hidden pb-[calc(72px+env(safe-area-inset-bottom))] nav:pb-0'
                : 'flex-1 overflow-y-auto overflow-x-hidden pb-[calc(72px+env(safe-area-inset-bottom))] nav:pb-0',
            )}
          >
            <Outlet />
          </div>
        </main>
      </div>
      <MobileBottomBar />
    </div>
  );
}
